import React, { useState, useEffect, useCallback } from 'react';
import api from '../common/lib/api';
import Errors, { useError } from '../common/components/Errors';
import { Spinner } from '@blueprintjs/core';
import naturalCompare from 'natural-compare';

export default function Page() {
  const [salesReps, setSalesReps] = useState({
    status: 'init',
    data: [],
  });
  const { errors, setErrors, handleError } = useError();

  const load = useCallback(async () => {
    try {
      const { data } = await api.get('/sales-reps');
      data.data.sort((a, b) => {
        return naturalCompare(a.name.toLowerCase(), b.name.toLowerCase())
      })
      setSalesReps({
        data: data.data,
        status: 'ready',
      });
    } catch (e) {
      handleError(e);
      setSalesReps((current) => ({
        ...current,
        status: 'error',
      }));
    }
  }, [handleError]);

  useEffect(() => {
    load();
  }, [load]);

  if (salesReps.status === 'init') {
    return <Spinner size='200' />;
  }

  return (
    <>
      <h1>Sales Reps</h1>

      {errors.length > 0 && <Errors.Callout errors={errors} setErrors={setErrors} />}

      <table className='bp3-html-table bp3-html-table-bordered bp3-html-table-condensed bp3-html-table-striped'>
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Phone</th>
          </tr>
        </thead>
        <tbody>
          {salesReps.data.map((rep) => {
            return (
              <tr>
                <td>{rep.name}</td>
                <td>{rep.email}</td>
                <td>{rep.phoneNumber}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
}
